import { createSlice } from "@reduxjs/toolkit";

export const settingsSlice = createSlice({
  name: "settings",
  initialState: {
    value: {
      propertyFields: [],
      contactFields: [],
      counties: [],
      loaded: false,
    },
  },
  reducers: {
    setDefinitions: (state, action) => {
      const defs = Array.isArray(action.payload) ? action.payload : [];
      state.value.propertyFields = defs.filter((d) => d.entity === "property");
      state.value.contactFields = defs.filter((d) => d.entity === "contact");
      state.value.loaded = true;
    },
    setCounties: (state, action) => {
      state.value.counties = Array.isArray(action.payload) ? action.payload : [];
    },
  },
});

export const { setDefinitions, setCounties } = settingsSlice.actions;

export default settingsSlice.reducer;
